import { Navigate, Outlet } from "react-router-dom";

import { useAuthStore } from "../Zustand/auth.store";

export function RequireRole({ allowAdmin }: { allowAdmin?: boolean }) {
  const isAdmin = useAuthStore((s) => s.isAdmin);

  if (isAdmin === undefined) {
    return <div>Loading...</div>;
  }

  if (allowAdmin && !isAdmin) {
    return <Navigate to="/home" replace />;
  }
  return <Outlet />;
}
